module.exports = __webpack_public_path__ + "media/images/promo/black_friday_2019/part1-81f2453f3c063680dff3618acca4f346.png";